module.exports = __webpack_public_path__ + "static/fonts/PingFang-Medium.1597485.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/css/PingFang-Medium.ttf
// module id = A5xE
// module chunks = 1